
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./event-store.cjs.production.min.js')
} else {
  module.exports = require('./event-store.cjs.development.js')
}
